import HomeView from "@/views/HomeView.vue";
import { createRouter, type RouterHistory } from "vue-router";

const HASH_SCROLL_GAP = 16;
const SITE_NAV_SELECTOR = "[data-site-nav]";
const SITE_NAV_ROW_SELECTOR = "[data-site-nav-row]";



function getHashScrollOffset() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return 0;
  }

  const nav = document.querySelector<HTMLElement>(SITE_NAV_SELECTOR);
  const navRow = document.querySelector<HTMLElement>(SITE_NAV_ROW_SELECTOR);

  if (!nav || !navRow) {
    return 0;
  }

  const navStyles = window.getComputedStyle(nav);

  if (navStyles.position !== "fixed" && navStyles.position !== "sticky") {
    return 0;
  }

  const verticalPadding =
    Number.parseFloat(navStyles.paddingTop) + Number.parseFloat(navStyles.paddingBottom);

  return Math.ceil(navRow.getBoundingClientRect().height + verticalPadding + HASH_SCROLL_GAP);
}

export const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/zamowienia",
    name: "order",
    component: () => import("@/views/OrderView.vue"),
  },
  {
    path: "/regulamin",
    name: "terms",
    component: () => import("@/views/TermsView.vue"),
  },
  {
    path: "/polityka-prywatnosci",
    name: "privacy",
    component: () => import("@/views/PrivacyView.vue"),
  },
  {
    path: "/dostawy-informacje",
    name: "deliveries",
    component: () => import("@/views/DeliveryView.vue"),
  },
  {
    path: "/podziekowanie",
    name: "thankyou",
    component: () => import("@/views/ThankYouView.vue"),
  },
  {
    path: "/status-zamowienia",
    name: "orderStatus",
    component: () => import("@/views/OrderStatusView.vue"),
  },
  { path: "/:pathMatch(.*)*", name: "NotFound", component: () => import("@/views/NotFoundView.vue") },
];

export function createAppRouter(history: RouterHistory) {
  return createRouter({
    history,
    routes,
    scrollBehavior(to) {
      if (to.hash) {
        return {
          el: to.hash,
          top: getHashScrollOffset(),
          behavior: "smooth",
        };
      }
      return { left: 0, top: 0 };
    },
  });
}
